import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import uiSlice from './uiReducer';
import authReducer from './authReducer';
import userReducer from './userReducer';
import customerReducer from './customersReducer';
import itemsReducer from './itemsReducer';
import suppliersReducer from './suppliersReducer';
import ordersReducer from './ordersReducer'
import coreReducer from './coreReducer';
import appointmentsReducer from './appointmentsReducer';

const authPersistConfig = {
    key: "auth",
    storage,
    whitelist: ["token", "refreshToken", "user", "role", "modules", "permissions", "tenant"]
};

const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    core: coreReducer,
    ui: uiSlice,
    user: userReducer,
    customers: customerReducer,
    items: itemsReducer,
    suppliers: suppliersReducer,
    orders: ordersReducer,
    appointments: appointmentsReducer
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/FLUSH",
                    "persist/REHYDRATE",
                    "persist/PAUSE",
                    "persist/PURGE",
                    "persist/REGISTER",
                ],
            },
        }),
});

export const persistor = persistStore(store);
